document.addEventListener("turbolinks:load", function() {
  iFrameResize({}, '#content-frame');
});
